<template>
  <div
    class="fixed left-full top-16 rounded overflow-hidden transform origin-top-left rotate-90 z-20"
    id="grid-controls"
  >
    <div
      class="transition-all bg-gray-100 duration-300"
      :class="expandControls ? 'h-8 w-64' : 'h-2 w-16'"
      @click="interact()"
    >
      <div class="flex flex-row" v-show="expandControls">
        <input
          type="range"
          name="ratio"
          min="0"
          max="100"
          step="1"
          class="flex-1 bg-transparent m-1.5 transform rotate-180"
          v-model.number="colorRatio"
          @mousedown="mouseDownHandler()"
          @mouseup="mouseUpHandler()"
          @touchstart="handleTouchStart()"
          @touchend="handleTouchEnd()"
        />
        <div
          @click="$emit('toggle')"
          class="text-white cursor-pointer transform -rotate-90"
          :class="drawMode.active ? 'text-gray-500' : 'text-gray-400'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5 m-1.5"
            viewBox="0 0 48 48"
            fill="currentColor"
          >
            <path
              d="M24 6c-9.94 0-18 8.06-18 18s8.06 18 18 18c1.66 0 3-1.34 3-3 0-.78-.29-1.48-.78-2.01-.47-.53-.75-1.22-.75-1.99 0-1.66 1.34-3 3-3h3.53c5.52 0 10-4.48 10-10 0-8.84-8.06-16-18-16zm-11 18c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm6-8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm10 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm6 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
            />
            <path d="M0 0h48v48h-48z" fill="none" />
          </svg>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="transition origin-top transform"
      leave-active-class="transition origin-top transform"
      enter-class="transform scale-y-0"
      leave-to-class="transform scale-y-0"
    >
      <div
        class="flex flex-row bg-gray-100 h-8 w-64 justify-between rounded-b"
        v-if="drawMode.active"
      >
        <div
          v-for="color in theme.colors"
          :key="color"
          class="w-5 h-5 m-1.5 rounded-full"
          :class="{
            'ring ring-inset ring-white ring-opacity-50':
              drawMode.color === color,
          }"
          @click="$emit('set-draw-mode-color', color)"
          :style="{ backgroundColor: color }"
        ></div>

        <div
          class="w-5 h-5 m-1.5 rounded-full"
          :class="{
            'ring ring-inset ring-white ring-opacity-50':
              drawMode.color === theme.gray,
          }"
          @click="$emit('set-draw-mode-color', theme.gray)"
          :style="{ backgroundColor: theme.gray }"
        ></div>
        <div
          class="flex flex-row justify-center w-5 h-5 m-1.5 text-gray-700 rounded-full transform -rotate-90"
          :class="{
            'bg-gray-400': drawMode.color === 'random',
          }"
          @click="$emit('set-draw-mode-color', 'random')"
        >
          <svg
            class="h-auto"
            width="90%"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xml:space="preserve"
            xmlns:serif="http://www.serif.com/"
            fill="currentColor"
            stroke="currentColor"
            style="
                      fill-rule: evenodd;
                      clip-rule: evenodd;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
          >
            <g>
              <g transform="matrix(1,0,0,1,0,3.94375)">
                <path
                  d="M18.747,9.747L21,12M21,12L18.747,14.253M21,12L14.345,12L8.392,4L3,4"
                  style="
                            fill: none;
                            fill-rule: nonzero;
                            stroke-width: 2px;
                          "
                />
              </g>
              <g transform="matrix(1,0,0,1,0,-4.05625)">
                <path
                  d="M18.764,9.764L21,12M21,12L18.764,14.236M21,12L14.345,12L8.392,20L3,20"
                  style="
                            fill: none;
                            fill-rule: nonzero;
                            stroke-width: 2px;
                          "
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    initialColorRatio: Number,
    drawMode: Object,
    theme: Object,
  },
  data() {
    return {
      colorRatio: this.initialColorRatio,
      updatingColorRatio: false,
      lastInteraction: Date.now(),
      now: Date.now(),
      interval: null,
    };
  },
  created() {
    var self = this;
    this.interval = setInterval(() => {
      self.now = Date.now();
    }, 500);
  },
  mounted() {
    this.lastInteraction = Date.now();
  },
  watch: {
    "drawMode.active": function() {
      this.interact();
    },
  },
  methods: {
    interact() {
      this.lastInteraction = Date.now();
      var self = this;
      window.clearInterval(this.interval);
      this.interval = setInterval(() => {
        self.now = Date.now();
      }, 500);
    },
    clearInterval() {
      window.clearInterval(this.interval);
      this.interval = null;
      this.now = Date.now();
    },
    mouseDownHandler() {
      this.updatingColorRatio = true;
    },
    mouseUpHandler() {
      this.updatingColorRatio = false;
      this.interact();
      this.$emit("update-color-ratio", this.colorRatio);
    },
    handleTouchStart() {
      document.body.style.overflow = "hidden";
      this.updatingColorRatio = true;
    },
    handleTouchEnd() {
      document.body.style.overflow = "auto";
      this.updatingColorRatio = false;
      this.interact();
      this.$emit("update-color-ratio", this.colorRatio);
    },
  },
  computed: {
    expandControls() {
      if (this.drawMode.active) {
        return true;
      } else if (this.updatingColorRatio) {
        return true;
      } else {
        if (this.now < this.lastInteraction + 1500) {
          return true;
        } else {
          this.clearInterval();
          return false;
        }
      }
    },
  },
};
</script>

<style scoped>
input[type="range"] {
  -webkit-appearance: none;
}
input[type="range"]:focus {
  outline: none;
}
input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  background: #9ca3af;
  border-radius: 2px;
}
input[type="range"]::-webkit-slider-thumb {
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background: #9ca3af;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;
}
input[type="range"]::-moz-range-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  background: #9ca3af;
  border-radius: 2px;
}
input[type="range"]::-moz-range-thumb {
  height: 16px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
}
input[type="range"]::-ms-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
}
input[type="range"]::-ms-fill-lower {
  background: #9ca3af;
  border-radius: 2.6px;
}
input[type="range"]::-ms-fill-upper {
  background: #9ca3af;
  border-radius: 2.6px;
}
input[type="range"]::-ms-thumb {
  height: 16px;
  width: 16px;
  border-radius: 3px;
  background: #9ca3af;
  cursor: pointer;
}
input[type="range"]:focus::-ms-fill-lower {
  background: #9ca3af;
}
input[type="range"]:focus::-ms-fill-upper {
  background: #9ca3af;
}
</style>
